

// ES6 Arrow Function
const Header = (props) => {
  return (
    <>
    <header>
    {props.children}
    </header>
    </>
  );
 };

// (2) --------------------------------------------

//  Using a higher-order component:

//  const withHeader = (HeaderComponent) => {
//       return (
//         <header>
//           <HeaderComponent {...this.props} />
//         </header>
//       );
//  };
 
// not completed

// const HeaderComponent = withHeader(Nav);

// --------------------------------------------

// (1) --------------------------------------------

// MISTAKEN OLD 
// function Header() {

//  return (
//   <>
//   <header>
//     Header
   
//   </header>
//   </>
//  );
// }

export default Header;
